export default {
  SET_LANGUAGE: 'SET_LANGUAGE',
  SET_PRODUCTS: 'SET_PRODUCTS',
  SET_SETTINGS: 'SET_SETTINGS',
  SET_TRANSLATIONS: 'SET_TRANSLATIONS',
  SET_USER: 'SET_USER',
};
